module.exports = __webpack_public_path__ + "static/c5-db6c868df0f71ab04ed69478976f9ff6.jpg";